import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { LoadAllFacade, SetInitialStateFacade } from '../../../../../../common/models';
import {
  SecurityQuestionAdd,
  SecurityQuestionDelete,
  SecurityQuestionLoad,
  SecurityQuestionSetId,
  SecurityQuestionSetType,
  SecurityQuestionsInitialState,
  SecurityQuestionUpdate,
  SecurityQuestionSavePositions,
} from './security-check.actions';
import { SecurityCheckState } from './security-check.state';
import { SecurityQuestionModel, SecurityQuestionSearchCriteria, SecurityQuestionTree } from '../../../../../models';
import { SecurityCheckContextType } from '../../../../../constants';
import { SecurityCheckTypeEnum, SecurityQuestionGroupEnum } from '../../../../../../store';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class SecurityCheckFacade implements LoadAllFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(SecurityCheckState.getLoaded);
  questionTree$: Observable<SecurityQuestionTree> = this.store.select(SecurityCheckState.getQuestionsTree);
  type$: Observable<SecurityCheckContextType> = this.store.select(SecurityCheckState.getType);
  id$: Observable<number> = this.store.select(SecurityCheckState.getId);

  constructor(private store: Store) {}

  loadAll(id: number): void {
    this.store.dispatch(
      new SecurityQuestionLoad({
        id,
        searchCriteria: new SecurityQuestionSearchCriteria(),
      }),
    );
  }

  setContextType(type: SecurityCheckContextType): void {
    this.store.dispatch(new SecurityQuestionSetType(type));
  }

  setContextId(id: number): void {
    this.store.dispatch(new SecurityQuestionSetId(id));
  }

  addSecurityQuestion(question: SecurityQuestionModel, dialog: MatDialogRef<unknown>): void {
    this.id$.pipe(filter(Boolean), take(1)).subscribe((id: number) => {
      this.store.dispatch(new SecurityQuestionAdd({ id, question, dialog }));
    });
  }

  updateSecurityQuestion(question: SecurityQuestionModel, dialog: MatDialogRef<unknown>): void {
    this.store.dispatch(new SecurityQuestionUpdate({ question, dialog }));
  }

  deleteSecurityQuestion(
    questionId: number,
    type: SecurityCheckTypeEnum,
    group: SecurityQuestionGroupEnum,
    dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>,
  ): void {
    this.store.dispatch(new SecurityQuestionDelete({ questionId, dialog, type, group }));
  }

  saveQuestionsPosition(questions: SecurityQuestionModel[]): void {
    this.store.dispatch(new SecurityQuestionSavePositions(questions));
  }

  setInitialState(): void {
    this.store.dispatch(new SecurityQuestionsInitialState());
  }
}
